import { Component, OnInit,  Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlowSheetService } from '../../services/flowsheet-service';
import { AlertComponent } from '../../common/alert/alert.component';
import { ModelRunDetail, ModelRunParameterDetail, FlowSheetRunDetail } from '../../models/flowsheet/model-run-details.model';
import { ActivatedRoute } from '@angular/router';
import { TenantService } from 'src/app/services/tenant.service';
import { Tenant } from 'src/app/models/tenant.model';

@Component({
  selector: 'app-flowsheet-run-details',
  templateUrl: './flowsheet-run-details.component.html',
  styleUrls: ['./flowsheet-run-details.component.css']
})
export class FlowSheetRunDetailsComponent implements OnInit {
  isLoading = true;
  flowSheetId: any;
  modelErrorMessage = 'Error';
  isLinear = false;
  flowSheetRunData = new FlowSheetRunDetail();
  modelDataList = [];
  modelRunDetails: any;
  selModel = new ModelRunDetail();
  inputsList = [];
  outputsList = [];
  stringLimit = 30;

  paramDisplayedColumns = ["parameterName", "value"]
  isShowParam = false;
  selModelUniqueId = '';
  inputDataSource: any;
  outputDataSource: any;

  currentTenant: Tenant;

  constructor(
    public globals: GlobalService,
    private readonly httpClientObj: HttpClient,
    public flowSheetService: FlowSheetService,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public tenantService: TenantService,
    public dialogRef: MatDialogRef<FlowSheetRunDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.getFlowSheetRunDetails();
  }

  getFlowSheetRunDetails() {
    this.flowSheetId = this.data.flowSheetId;
    this.tenantService.setActivatedTenantId(this.data.tenantId);
    this.getLatestRunDetails();
  }

  getLatestRunDetails() {
    this.flowSheetService.getLatestRunDetails(this.flowSheetId).subscribe((data: any): void => {
      if (data.modelRunDetails.length > 0) {

        this.flowSheetRunData.flowSheetId = data.flowSheetId;
        this.flowSheetRunData.flowSheetName = data.flowSheetName;
        this.flowSheetRunData.flowSheetRunId = data.flowSheetRunId;
        this.flowSheetRunData.status = data.status;
        this.flowSheetRunData.startTime = data.runStartDateTimeStamp;
        this.flowSheetRunData.endTime = data.runEndDateTimeStamp;
        this.flowSheetRunData.runCreatedBy = data.runCreatedBy;

        this.modelRunDetails = data.modelRunDetails;

        data.modelRunDetails.forEach((modelData) => {
          let modelDataObj = new ModelRunDetail();
          modelDataObj.modelUniqueId = modelData.modelUniqueId;
          modelDataObj.modelName = modelData.modelName;
          modelDataObj.status = modelData.status;
          modelDataObj.startTime = modelData.runStartDateTimeStamp;
          modelDataObj.endTime = modelData.runEndDateTimeStamp;

          this.modelDataList.push(modelDataObj);

        });

        this.selModel = this.modelDataList[0];
        this.showParameters();
      } else {
        this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching Model run details!" });
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching FlowSheet runs List!" });
      this.isLoading = false;
    });
  }

  showParameters() {
    this.isShowParam = true;
    this.inputsList = [];
    this.outputsList = [];
    this.selModelUniqueId = this.selModel.modelUniqueId;
    let modelData = this.modelRunDetails.find(r => r.modelUniqueId == this.selModel.modelUniqueId);

    modelData.inputParameters.forEach((param) => {
      let paramData = new ModelRunParameterDetail();
      paramData.parameterName = param.parameterName;
      paramData.value = param.parameterRunValue;
      paramData.parameterDisplayName = param.captionName;

      this.inputsList.push(paramData);
    });

    this.inputDataSource = new MatTableDataSource(this.inputsList);

    modelData.outputParameters.forEach((param) => {
      let paramData = new ModelRunParameterDetail();
      paramData.parameterName = param.parameterName;
      paramData.value = param.parameterRunValue;
      paramData.parameterDisplayName = param.captionName;

      this.outputsList.push(paramData);
    });

    this.outputDataSource = new MatTableDataSource(this.outputsList);

  }  

  onCancelClick() {
    this.dialogRef.close(false);
  }
}

